
import { Injectable } from '@angular/core'
import { ENV, LoggerService } from '@danangelus/ngx-app-core'
import packageJson from '../../../../package.json'

export const APP_VERSION = packageJson.version
const log: LoggerService = LoggerService.get('VersionCheckService')

/**
 * Service to check that current version is the latest
 *
 * @author Dan Bennett
 */
@Injectable({
    providedIn: 'root'
})
export class VersionCheckService {

    lastVersionAfterCheck: string | undefined = undefined

    check(): void {
        const latestVersion = ENV.config.get('version') || APP_VERSION
        this.lastVersionAfterCheck = latestVersion

        if (this.lastVersionAfterCheck === latestVersion && APP_VERSION !== latestVersion) {
            log.warn(`[check] Current version ${APP_VERSION} is not the latest version ${latestVersion} even after a refresh!`)
        }
        if (this.lastVersionAfterCheck !== latestVersion && APP_VERSION !== latestVersion) {
            window.location.reload()
        }
    }
}
